// extracted by mini-css-extract-plugin
module.exports = {"tandemSelect":"Select_tandemSelect__3egxy"};